import { FlexCol, FlexRow } from '@/components/common/Flex';
import { ButtonProps, FlexProps } from '@chakra-ui/react';
import { TrackingData, TrackingEventName } from '@common/react/tracking';
import { Subheader } from '../common/Typography';
import { Button } from './Button';

export interface CardLayoutProps extends FlexProps {
    title: string;
    primaryButtonText: string;
    isPrimaryButtonLoading?: boolean;
    primaryButtonProps?: ButtonProps;
    onPrimaryButton?: VoidFunction;
    secondaryButtonText?: string;
    isSecondaryButtonLoading?: boolean;
    secondaryButtonProps?: ButtonProps;
    onSecondaryButton: VoidFunction;
    onClickPrimaryEvent: TrackingEventName;
    onClickPrimaryEventParams?: TrackingData;
    onClickSecondaryEvent: TrackingEventName;
    onClickSecondaryEventParams?: TrackingData;
}

const CardLayout = ({
    title,
    primaryButtonText,
    isPrimaryButtonLoading,
    primaryButtonProps,
    onPrimaryButton,
    secondaryButtonText = 'Cancel',
    isSecondaryButtonLoading,
    secondaryButtonProps,
    onSecondaryButton,
    children,
    onClickPrimaryEvent,
    onClickPrimaryEventParams,
    onClickSecondaryEvent,
    onClickSecondaryEventParams,
    ...props
}: CardLayoutProps) => {
    return (
        <FlexCol {...props}>
            <Subheader mb={8}>{title}</Subheader>
            <FlexRow grow={1} mb={12}>
                {children}
            </FlexRow>
            <FlexRow justifyContent="flex-end" gap={4}>
                <Button
                    variant="ghost"
                    colorScheme="gray"
                    onClick={onSecondaryButton}
                    onClickEvent={onClickSecondaryEvent}
                    onClickEventParams={onClickSecondaryEventParams}
                    isLoading={isSecondaryButtonLoading}
                    {...secondaryButtonProps}
                >
                    {secondaryButtonText}
                </Button>
                <Button
                    onClick={onPrimaryButton}
                    onClickEvent={onClickPrimaryEvent}
                    onClickEventParams={onClickPrimaryEventParams}
                    isLoading={isPrimaryButtonLoading}
                    isDisabled={!onPrimaryButton}
                    {...primaryButtonProps}
                >
                    {primaryButtonText}
                </Button>
            </FlexRow>
        </FlexCol>
    );
};

export default CardLayout;
